import BaseButton from "@/components_v2/Button/BaseButton";
import { BaseBannerProps } from "./types";

import "./styles.css";

const DEFAULT_BACKGROUND_COLOR = "#fff8f1";

const BaseBanner = ({
  title,
  description,
  icon,
  button: buttonProps,
  titleColor,
  descriptionColor,
  backgroundColor = DEFAULT_BACKGROUND_COLOR,
  className,
  style,
}: BaseBannerProps) => {
  return (
    <div
      className={`base-banner flex items-center gap-300 ${className ?? ""}`.trim()}
      style={{ ...style, backgroundColor }}
      role="region"
      aria-label={title}
    >
      {icon != null && (
        <div className="flex items-center justify-center flex-shrink-0">
          {icon}
        </div>
      )}

      <div className="base-banner-content flex-1">
        <h2
          className="base-banner-title header-s-medium"
          style={titleColor ? { color: titleColor } : undefined}
        >
          {title}
        </h2>
        {description && (
          <p
            className="base-banner-description body-m-regular"
            style={descriptionColor ? { color: descriptionColor } : undefined}
          >
            {description}
          </p>
        )}
      </div>

      {buttonProps && (
        <div className="base-banner-action">
          <BaseButton {...buttonProps} />
        </div>
      )}
    </div>
  );
};

export default BaseBanner;
